import { Instagram as IgIcon } from "lucide-react";

const TILES = [
  "https://images.unsplash.com/photo-1567225557594-88d73e55f2cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbmRvb3IlMjBwbGFudHN8ZW58MHx8fHwxNzc5MDk1MTcyfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1614594975525-e45190c55d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbmRvb3IlMjBwbGFudHN8ZW58MHx8fHwxNzc5MDk1MTcyfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1614594895304-fe7116ac3b58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBpbmRvb3IlMjBwbGFudHN8ZW58MHx8fHwxNzc5MDk1MTcyfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1604762525953-2c80447cc4a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbmRvb3IlMjBwbGFudHN8ZW58MHx8fHwxNzc5MDk1MTcyfDA&ixlib=rb-4.1.0&q=85",
];

const HANDLE = "indoorgreensin";
const IG_URL = `https://www.instagram.com/${HANDLE}/`;

export default function InstagramSection() {
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative bg-[#F9F8F6] py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 mb-14 sm:mb-20">
          <div className="reveal max-w-2xl">
            <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
              07 / Field notes
            </p>
            <h2 className="font-[Outfit] font-extralight text-[#2D332B] text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.015em]">
              Follow along on{" "}
              <a
                href={IG_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-handle-link"
                className="italic text-[#8A9A86] link-underline"
              >
                @{HANDLE}
              </a>
            </h2>
          </div>
          <a
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta"
            className="reveal inline-flex items-center gap-3 self-start sm:self-end px-5 py-3 border border-[#2D332B] text-[#2D332B] text-[11px] tracking-[0.25em] uppercase hover:bg-[#2D332B] hover:text-[#F9F8F6] transition-colors duration-500 rounded-sm"
          >
            <IgIcon className="w-4 h-4" />
            View Instagram
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {TILES.map((src, i) => (
            <a
              key={i}
              href={IG_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="reveal relative block aspect-square overflow-hidden rounded-sm group"
            >
              <img
                src={src}
                alt={`Indoor Greens Instagram post ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-[#2D332B]/0 group-hover:bg-[#2D332B]/35 transition-colors duration-500 flex items-center justify-center">
                <IgIcon className="w-7 h-7 text-[#F9F8F6] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
